import React from 'react';
import SearchFieldsActions from 'actions/search/SearchFieldsActions';
import VotingRadioButtonsSearchFieldContainer from 'components/stateful/search/VotingRadioButtonsSearchFieldContainer';
import 'styles/search/RadioButtonsSearchField.styl';

/**
 * Render all the specific `RadioButtonsSearchField` components. For now, it supports only the "Voting" search fields:
 *
 * 1) Calls I rated as good/bad
 * 2) Calls others rated as good/bad
 *  2.a) Anybody
 *  2.b) The rep who made the call (skipped since it requires all accounts' reindex -- see EV-8046)
 *  2.c) The rep's manager (skipped since it requires all accounts' reindex -- see EV-8046)
 *  2.d) Member of team
 *  2.e) Member of department
 */
class RadioButtonsSearchWidgets extends React.PureComponent {
  searchFieldToggled(searchField) {
    if (this.props.searchFieldsToggled) {
      return this.props.searchFieldsToggled.get(searchField.name);
    }
    return false;
  }

  onUpdateSelectedRadioButtonKey = (searchField, key) => {
    SearchFieldsActions.updateRadioButtonsSelectedKey(searchField, key);
  };

  /**
   * Render radio buttons for the given search field
   * @param {searchField} searchField  search field to render
   * @return {JSX} radio buttons search widget
   */
  renderComponent(searchField) {
    return (
      <VotingRadioButtonsSearchFieldContainer
        key={searchField.name}
        searchField={searchField}
        toggled={this.searchFieldToggled(searchField)}
        searchFieldsState={this.props.searchFieldsState}
        shouldFocus={this.props.shouldRenderToggled && this.searchFieldToggled(searchField)}
        updateLastToggledOnSearchWidget={this.props.updateLastToggledOnSearchWidget}
        onUpdateSelectedOptionKey={this.onUpdateSelectedRadioButtonKey}
      />
    );
  }

  /**
   * Return true/false that indicates whether the radio buttons search field for voting should be rendered or not
   * @param searchField 'Voting' search field
   * @returns {boolean} true if the radio buttons component should be rendered; false if not
   */
  shouldNotRenderComponent(searchField) {
    return !(
      (this.props.shouldRenderToggled && this.searchFieldToggled(searchField)) ||
      (this.props.shouldRenderNotToggled && !this.searchFieldToggled(searchField))
    );
  }

  /**
   * Render radio buttons and nested radio buttons/dropdowns for the 'Voting' search field
   * @return {JSX} radio buttons and nested radio buttons/dropdowns
   */
  render() {
    const searchFields = this.props.searchFields.sort(sf => sf.order);
    return (
      <div className="search-widget">
        {searchFields
          .filterNot(this.shouldNotRenderComponent, this)
          .map(this.renderComponent, this)}
      </div>
    );
  }
}

export default RadioButtonsSearchWidgets;
